module.exports = "/_next/static/images/navya-889c400a458a6cfaefb40cf051877876.png";